export default "__VITE_ASSET__DbF2Vk$F__"